import { ActionBar, Button } from '@components'
import { useBusinessContext } from '@context'
import { createPeriod } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaPlus } from 'react-icons/fa'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const PeriodActionBar: React.FC = () => {
  const [t] = useTranslation()
  const queryClient = useQueryClient()
  const { slug } = useBusinessContext()

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: () => createPeriod({ slug }, {}),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [slug, 'periods'] })
      }
    }
  })

  const primaryButtons = [
    <Button
      key="create-button"
      icon={<FaPlus />}
      onClick={() => mutate()}
      showSpinner={isLoading}
      disabled={isLoading}
    >
      {t('period.createNew')}
    </Button>
  ]

  return <ActionBar primaryButtons={primaryButtons} />
}
